import React, {FC, useContext} from "react";
import {BrowserRouter, Route, Switch} from "react-router-dom";
import {Page} from "./types";
import ScrollToTop from "./ScrollToTop";
import Footer from "components/Footer/Footer";
import Page404 from "containers/Page404/Page404";
import PageSingle from "containers/PageSingle/PageSingle";
import PageAbout from "containers/PageAbout/PageAbout";
import PageContact from "containers/PageContact/PageContact";
import PageLogin from "containers/PageLogin/PageLogin";
import PageSignUp from "containers/PageSignUp/PageSignUp";
import PageForgotPass from "containers/PageForgotPass/PageForgotPass";
import PageDashboard from "containers/PageDashboard/PageDashboard";
import PageSubscription from "containers/PageSubscription/PageSubscription";
import HeaderContainer from "containers/HeaderContainer/HeaderContainer";
import PageHome from "containers/PageHome/PageHome";
import MediaRunningContainer from "containers/MediaRunningContainer/MediaRunningContainer";
import MediaRunningContainerForSafari from "containers/MediaRunningContainer/MediaRunningContainerForSafari";
import isSafariBrowser from "utils/isSafariBrowser";
import ProtectedRoute from "../containers/ProtectedRoutes/ProtectedRoute";
import PageMarkets from "containers/PageMarkets/PageMarkets";
import PageLearn from "containers/PageLearn/PageLearn";
import PageBlog from "containers/PageBlog/PageBlog";
import PageCoin from "../containers/PageCoin/PageCoin";
import PageVerification from "../containers/PageVerification/PageVerification"
import {AuthContext} from "../global/AuthContext";
import PageSearch from "containers/PageSearch/PageSearch";
import PageAuthor from "containers/PageAuthor/PageAuthor";

export const pages: Page[] = [
    {path: "/", exact: true, component: PageHome},
    {path: "/#", exact: true, component: PageHome},
    {path: "/single/:uid/:slug", component: PageSingle},
    {path: "/coin/:coin", component: PageCoin},
    {path: "/about", component: PageAbout},
    {path: "/Markets", component: PageMarkets},
    {path: "/Learn", component: PageLearn},
    {path: "/contact", component: PageContact},
    {path: "/page404", component: Page404},
    {path: "/signup", component: PageSignUp},
    {path: "/forgot-pass", component: PageForgotPass},
    {path: "/subscription", component: PageSubscription},
    {path: "/Blog", component: PageBlog},
    {path: "/verification", component: PageVerification},
    { path: "/author/the-demo-author-slug/:uid", component: PageAuthor },
    { path: "/search", component: PageSearch }
];

export interface RoutesProps {
    className?: string;
    isAuth: boolean;
    isVerified: boolean;
}

const Routes: FC<RoutesProps> = ({isAuth, isVerified}) => {
    const {setIsAuth} = useContext(AuthContext);

    return (
        <BrowserRouter
            basename={
                process.env.REACT_APP_LRT_OR_RTL === "rtl" ? "/CryptoVerse-rtl" : "/CryptoVerse"
            }
        >
            <ScrollToTop/>
            <HeaderContainer/>
            <Switch>
                {pages.map(({component, path, exact}) => {
                    return (
                        <Route
                            key={path}
                            component={component}
                            exact={!!exact}
                            path={path}
                        />
                    );
                })}
                {<Route path='/login' component={() => <PageLogin setAuth={setIsAuth}/>}/>}
                <ProtectedRoute isAuth={isAuth} isVerified={isVerified} component={PageDashboard} path='/dashboard'/>
                <Route component={Page404}/>
            </Switch>
            <Footer/>
            {isSafariBrowser() ? (
                <MediaRunningContainerForSafari/>
            ) : (
                <MediaRunningContainer/>
            )}
        </BrowserRouter>
    );
};

export default Routes;
